module.exports = __webpack_public_path__ + "static/media/phone-laptop.2ba79236.svg";